import type { IconProps } from '@uncinc/uncinc-react-kitchen-sink/dist/components/Icon';

import type { SearchAllContentTaxonomyHit } from '../SearchAllContent/types';

/**
 * Maps icon fields for elastic search hits of entity type
 * 'taxonomy_term' to generic Icon name and flair.
 *
 * @param {Object} hit
 *   Elastic search hit.
 *
 * @returns {Object}
 *   Icon name and flair as an object.
 */
export default function searchTaxonomyIconMapper(hit: SearchAllContentTaxonomyHit) {
  let flair: IconProps['flair'];

  if (hit.taxonomy_icon_family?.[0]) {
    flair = hit.taxonomy_icon_family[0] === 'baseline' ? 'filled' : hit.taxonomy_icon_family[0];
  }

  return {
    name: hit.taxonomy_icon_name?.[0],
    flair,
  };
}
